import { useTranslate } from "@obsbot/remo-i18n";
import "./index.less";

import { Input, Select } from "antd";
import React, { Fragment, useEffect } from "react";

// to distinguish phone and email
const phoneRegex = /^\d+$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateInput(account: string): boolean {
    return phoneRegex.test(account) || emailRegex.test(account);
}

export interface LoginAccountProps {
    placeholder?: string;
    value?: string;
    // history props
    onFocus?: () => void;
    password?: string;
    accountHistory?: Array<{ account: string; password: string; countryCode?: string | null }> | [];
    onHistoryChange?: (options: any) => void;
}

export const LoginAccount: React.FC<LoginAccountProps> = ({
    placeholder,
    password,
    value,
    accountHistory,
    onHistoryChange,
    ...restProps
}) => {
    const defaultAccount = accountHistory?.length ? accountHistory[0] : null;
    const t = useTranslate();

    useEffect(() => {
        if (defaultAccount) {
            if (!value || validateInput(value)) {
                console.log("default account", defaultAccount);
            }
        }
        // report to parent component if there is changing
    }, [value, defaultAccount]);

    return (
        <Fragment>
            <div className="login-account-title">
                <span>{t("login-page.phone-or-email")}</span>
            </div>
            <Input
                addonAfter={
                    accountHistory?.length ? (
                        <Select
                            labelInValue
                            // “bordered” 已弃用，根据 Ant Design 文档，可使用 className 自定义样式来移除边框
                            className="ant-select-borderless"
                            placement="bottomRight"
                            value={{ key: password, value }}
                            onChange={onHistoryChange}
                        >
                            {accountHistory.map(accountItem => {
                                return (
                                    <Select.Option
                                        key={accountItem.password}
                                        title={accountItem.account}
                                        value={accountItem.account}
                                    >
                                        {accountItem.account}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    ) : null
                }
                autoComplete="off"
                className="login-account"
                placeholder={placeholder}
                value={value}
                onKeyDown={e => {
                    if ((e.ctrlKey || e.metaKey) && e.key === "z") {
                        e.preventDefault();
                    }
                }}
                {...restProps}
            />
        </Fragment>
    );
};
